import { render, staticRenderFns } from "./error.vue?vue&type=template&id=6143fb46&scoped=true"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=6143fb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143fb46",
  null
  
)

export default component.exports